import { renderToStaticMarkup as baseRenderToStaticMarkup } from 'react-dom/server';

import Reader, { TReaderDocument } from '../Reader/core';

type TOptions = {
  rootBlockId: string;
};
export default function renderToStaticMarkup(document: TReaderDocument, { rootBlockId }: TOptions) {
  const htmlAttributes = {
    lang: 'es',
    xmlns: 'http://www.w3.org/1999/xhtml',
  };

  return (
    '<!DOCTYPE html>' +
    baseRenderToStaticMarkup(
      <html {...htmlAttributes}>
        <head>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
          <meta name="x-apple-disable-message-reformatting" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        </head>
        <body style={{ margin: 0, padding: 0 }}>
          <Reader document={document} rootBlockId={rootBlockId} />
        </body>
      </html>,
    )
  );
}
